'use client';
import { useEffect, useState } from 'react';
import { FormControl } from 'react-bootstrap';
import { ChevronDown } from 'react-feather';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import classes from './FilterComps.module.css';

const DimensionsFilter = (props) => {
	const [showDimensions, setShowDimensions] = useState(false);
	// State for dimensions
	const [height, setHeight] = useState({ min: null, max: null });
	const [length, setLength] = useState({ min: null, max: null });
	const [depth, setDepth] = useState({ min: null, max: null });

	const router = useRouter();
	const searchParams = useSearchParams();
	const pathname = usePathname();

	const handleDimensionChange = (setter) => (e) => {
		const { name, value } = e.target;
		setter((prev) => ({ ...prev, [name]: value === '' ? null : value }));
	};

	// useEffect to update URL when state changes
	useEffect(() => {
		let params = new URLSearchParams(window.location.search);

		if (height.min !== null || height.max !== null) {
			let minHeightValue = height.min !== null ? height.min : '';
			let maxHeightValue = height.max !== null ? height.max : '';

			if (minHeightValue !== '') {
				params.set('minHeight', minHeightValue);
			} else {
				params.delete('minHeight');
			}

			if (maxHeightValue !== '') {
				params.set('maxHeight', maxHeightValue);
			} else {
				params.delete('maxHeight');
			}
		} else {
			params.delete('minHeight');
			params.delete('maxHeight');
		}

		if (length.min !== null || length.max !== null) {
			let minLengthValue = length.min !== null ? length.min : '';
			let maxLengthValue = length.max !== null ? length.max : '';

			if (minLengthValue !== '') {
				params.set('minLength', minLengthValue);
			} else {
				params.delete('minLength');
			}

			if (maxLengthValue !== '') {
				params.set('maxLength', maxLengthValue);
			} else {
				params.delete('maxLength');
			}
		} else {
			params.delete('minLength');
			params.delete('maxLength');
		}

		// Handling the minDepth and maxDepth
		if (depth.min !== null || depth.max !== null) {
			let minDepthValue = depth.min !== null ? depth.min : '';
			let maxDepthValue = depth.max !== null ? depth.max : '';

			if (minDepthValue !== '') {
				params.set('minDepth', minDepthValue);
			} else {
				params.delete('minDepth');
			}

			if (maxDepthValue !== '') {
				params.set('maxDepth', maxDepthValue);
			} else {
				params.delete('maxDepth');
			}
		} else {
			params.delete('minDepth');
			params.delete('maxDepth');
		}

		const updateURL = () => {
			router.push(pathname + '?' + params.toString());
		};

		// Clear any existing timeout
		if (window.updateTimeout) {
			clearTimeout(window.updateTimeout);
		}

		// Set a new timeout to delay the update
		window.updateTimeout = setTimeout(updateURL, 500);

		// Cleanup timeout when component unmounts
		return () => {
			if (window.updateTimeout) {
				clearTimeout(window.updateTimeout);
			}
		};
	}, [height, length, depth]);

	return (
		<>
			<div className={classes.desktop}>
				<div className={classes.dropDown}>
					<div
						onClick={() => setShowDimensions(!showDimensions)}
						className={classes.justifyBetween}
					>
						Dimensions
						<ChevronDown
							size={13}
							className={showDimensions ? classes.flip : classes.icon}
						/>
					</div>
					{showDimensions && (
						<>
							<div className={classes.box}>
								<div className={classes.dimensionsTitle}> Height</div>

								<div className={classes.dimensionsContainer}>
									<div className={classes.dimInput}>
										<FormControl
											name="min"
											value={height.min || ''}
											onChange={handleDimensionChange(setHeight)}
											aria-label="Small"
											aria-describedby="inputGroup-sizing-sm"
											type="number"
											placeholder="min(0)"
											className={classes.priceInput}
										/>
										<p className={classes.dimInputTxt}>in</p>
									</div>
									<div className={classes.dash}>
										<div className={classes.line} />
									</div>
									<div className={classes.dimInput}>
										<FormControl
											name="max"
											value={height.max || ''}
											onChange={handleDimensionChange(setHeight)}
											aria-label="Small"
											aria-describedby="inputGroup-sizing-sm"
											type="number"
											placeholder="max"
											className={classes.priceInput}
										/>
										<p className={classes.dimInputTxt}>in</p>
									</div>
								</div>
							</div>
							<div className={classes.box}>
								<div className={classes.dimensionsTitle}> Length</div>

								<div className={classes.dimensionsContainer}>
									<div className={classes.dimInput}>
										<FormControl
											name="min"
											value={length.min || ''}
											onChange={handleDimensionChange(setLength)}
											aria-label="Small"
											aria-describedby="inputGroup-sizing-sm"
											type="number"
											placeholder="min(0)"
											className={classes.priceInput}
										/>
										<p className={classes.dimInputTxt}>in</p>
									</div>
									<div className={classes.dash}>
										<div className={classes.line} />
									</div>
									<div className={classes.dimInput}>
										<FormControl
											name="max"
											value={length.max || ''}
											onChange={handleDimensionChange(setLength)}
											aria-label="Small"
											aria-describedby="inputGroup-sizing-sm"
											type="number"
											placeholder="max"
											className={classes.priceInput}
										/>
										<p className={classes.dimInputTxt}>in</p>
									</div>
								</div>
							</div>
							<div className={classes.box}>
								<div className={classes.dimensionsTitle}> Depth</div>

								<div className={classes.dimensionsContainer}>
									<div className={classes.dimInput}>
										<FormControl
											name="min"
											value={depth.min || ''}
											onChange={handleDimensionChange(setDepth)}
											aria-label="Small"
											aria-describedby="inputGroup-sizing-sm"
											type="number"
											placeholder="min(0)"
											className={classes.priceInput}
										/>
										<p className={classes.dimInputTxt}>in</p>
									</div>
									<div className={classes.dash}>
										<div className={classes.line} />
									</div>
									<div className={classes.dimInput}>
										<FormControl
											name="max"
											value={depth.max || ''}
											onChange={handleDimensionChange(setDepth)}
											aria-label="Small"
											aria-describedby="inputGroup-sizing-sm"
											type="number"
											placeholder="max"
											className={classes.priceInput}
										/>
										<p className={classes.dimInputTxt}>in</p>
									</div>
								</div>
							</div>
						</>
					)}

					{/* <div className={classes.mobileVisible}></div> */}
				</div>
			</div>
		</>
	);
};

export default DimensionsFilter;
